import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setErrorMessage } from "../../../../../redux/actions/error";
import { getConsent } from "../../../../../redux/actions/call";
const POLL_INTERVAL_MS = 8000;

const useConsentPolling = (zmClient, esProfesional) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const idRoom = searchParams.get("id");

  const noIngresoPaciente =
    zmClient?.getAllUser()?.every((user) => user.userIdentity !== "Paciente") ??
    true;

  useEffect(() => {
    if (!esProfesional || !noIngresoPaciente || !idRoom) {
      return undefined;
    }

    let intervalId;

    const poll = () => {
      dispatch(getConsent(idRoom, true)).then((res) => {
        const data = res?.value;
        if (!data?.solicitaConsentimiento) {
          clearInterval(intervalId);
          return;
        }
        if (data.consentimiento === false) {
          dispatch(
            setErrorMessage(
              "403",
              "El Paciente NO aceptó los términos y consentimiento de atención virtual.",
            ),
          );
          clearInterval(intervalId);
          return;
        }
        if (data.consentimiento === true) {
          clearInterval(intervalId);
        }
      });
    };

    poll();
    intervalId = setInterval(poll, POLL_INTERVAL_MS);
    return () => clearInterval(intervalId);
  }, [dispatch, esProfesional, noIngresoPaciente, idRoom]);
};

export default useConsentPolling;
